// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-2C34tq9z"};